import { ResponseType } from '../../shared/api/types';
import mrtAxiosV2 from '../../shared/utils/mrtAxiosV2';
import DomainManager from '../../shared/utils/DomainManager';

export interface SignoutResponseType extends ResponseType {
  readonly data: Record<string, never>;
}

export const fetchSignout = (targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return mrtAxiosV2(targetEnv, { isWebView: false }).post<SignoutResponseType>(
    `${domainManager.getApiDomain()}/member/v1/sign-out`
  );
};
